import { useId } from "@reach/auto-id";
import React from "react";
import styled from "styled-components";
import { Button, ButtonVariation } from "../Button";

import { mediaQueries } from "../style";
import { DetailsRow } from "./DetailsRow";
import type { ContentProps } from "./Content";

export const ToggleContentButton = styled(Button)``;

type SettingsActionRowProps = {
  id?: string;
  title?: React.ReactNode;
  buttonLabel?: string;
  buttonVariation?: ButtonVariation;
  disabled?: boolean;
  isOpen: boolean;
  onToggle: () => void;
  forceInlineReveal?: boolean;
  actionComponent?: React.ReactElement;
  innerRef?: React.MutableRefObject<any>;
  children: Array<React.ReactElement<ContentProps>>;
  disableClickAway?: boolean;
};

export const SettingsActionRow: React.FC<SettingsActionRowProps> = ({
  id = "",
  title = "",
  buttonLabel = "",
  buttonVariation,
  disabled,
  isOpen,
  onToggle,
  forceInlineReveal = false,
  actionComponent,
  innerRef,
  children,
  disableClickAway = false,
}) => {
  const isMobile = !mediaQueries.mediumMin.useMatchesBreakpoint();
  const settingActionRowId = id || useId();

  const toggleButton =
    isOpen && (!isMobile || forceInlineReveal) ? null : actionComponent ? (
      actionComponent
    ) : (
      <ToggleContentButton
        compact
        onClick={onToggle}
        variation={isMobile ? "icon" : buttonVariation ?? "tertiary"}
        icon={isMobile ? "arrow-right" : undefined}
        disabled={disabled}
        aria-label={buttonLabel}
        aria-expanded={isOpen}
      >
        {!isMobile && buttonLabel}
      </ToggleContentButton>
    );

  return (
    <DetailsRow title={title} actionNode={toggleButton} id={settingActionRowId} innerRef={innerRef}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            isOpen,
            onToggle,
            title,
            forceInlineReveal,
            disableClickAway,
          } as any);
        } else {
          throw Error("SettingsActionRow can only contain <DefaultContent> or <RevealContent> descendant elements.");
        }
      })}
    </DetailsRow>
  );
};
